import { ThemePalette } from '@angular/material/core';

export interface BADGECOLORS {
  WARN: ThemePalette;
}

export const BADGECOLORS: BADGECOLORS = {
  WARN: 'warn',
};
export interface COLORS {
  ABB_PRIMARY: string;
  ABB_BLACK: string;
  ABB_WHITE: string;
  ABB_GRAY_01: string;
  ABB_GRAY_02: string;
  ABB_GRAY_03: string;
  ABB_GRAY_04: string;
  ABB_GRAY_05: string;
  ABB_GRAY_06: string;
  MUTED: any;
}

export const COLORS: COLORS = {
  ABB_PRIMARY: 'rgb(var(--abb-color-primary))',
  ABB_BLACK: 'rgb(var(--abb-color-black))',
  ABB_WHITE: 'rgb(var(--abb-color-white))',
  ABB_GRAY_01: 'rgb(var(--abb-color-gray-01))',
  ABB_GRAY_02: 'rgb(var(--abb-color-gray-02))',
  ABB_GRAY_03: 'rgb(var(--abb-color-gray-03))',
  ABB_GRAY_04: 'rgb(var(--abb-color-gray-04))',
  ABB_GRAY_05: 'rgb(var(--abb-color-gray-05))',
  ABB_GRAY_06: 'rgb(var(--abb-color-gray-06))',
  MUTED: {
    100: '#fafafa',
    150: '#f5f5f5',
    200: '#ebebeb',
    300: '#dbdbdb',
    400: '#dcdcdc',
    500: '#bababa',
    600: '#afafaf',
    700: '#787878',
    800: '#5c5c5c',
    900: '#3e3e3e',
  },
};

export enum COLOR {
  ABB_PRIMARY = 'abb-primary',
  ABB_BLACK = 'abb-black',
  ABB_WHITE = 'abb-white',
  ABB_GRAY_01 = 'abb-gray-01',
  ABB_GRAY_02 = 'abb-gray-02',
  ABB_GRAY_03 = 'abb-gray-03',
  ABB_GRAY_04 = 'abb-gray-04',
  ABB_GRAY_05 = 'abb-gray-05',
  ABB_GRAY_06 = 'abb-gray-06',
}

export const PALETTE = {
  primary: 'color-primary',
  'primary-light': 'color-primary-light',
  'primary-dark': 'color-primary-dark',
  black: 'abb-color-black',
  'black-light': 'abb-color-black-light',
  'black-dark': 'abb-color-black-dark',
  white: 'abb-color-white',
  'white-light': 'abb-color-white-light',
  'white-dark': 'abb-color-white-dark',
  'gray-01': 'abb-color-gray-01',
  'gray-01-light': 'abb-color-gray-01-light',
  'gray-01-dark': 'abb-color-gray-01-dark',
  'gray-02': 'abb-color-gray-02',
  'gray-02-light': 'abb-color-gray-02-light',
  'gray-02-dark': 'abb-color-gray-02-dark',
  'gray-03': 'abb-color-gray-03',
  'gray-03-light': 'abb-color-gray-03-light',
  'gray-03-dark': 'abb-color-gray-03-dark',
  'gray-04': 'abb-color-gray-04',
  'gray-04-light': 'abb-color-gray-04-light',
  'gray-04-dark': 'abb-color-gray-04-dark',
  'gray-05': 'abb-color-gray-05',
  'gray-05-light': 'abb-color-gray-05-light',
  'gray-05-dark': 'abb-color-gray-05-dark',
  'gray-06': 'abb-color-gray-06',
  'gray-06-light': 'abb-color-gray-06-light',
  'gray-06-dark': 'abb-color-gray-06-dark',
  success: 'abb-color-success',
  warning: 'abb-color-warning',
  error: 'abb-color-error',
  'base-value-color-font': 'base-value-color-font',
} as const;

export const CHART_COLORS = [
  '#ff000f',
  '#262626',
  '#6e6e6e',
  '#4dc9f6',
  '#f67019',
  '#f53794',
  '#537bc4',
  '#acc236',
  '#166a8f',
  '#00a950',
  '#58595b',
  '#8549ba',
];
